import { Arbitro, ArbitroJSON } from '../Arbitro/Arbitro';
import { Usuario, UsuarioJSON } from '../Usuario/Usuario';
export interface ArbitroParejaJSON {
  ap_id: string;
  ap_arbid_1: string;
  ap_arbid_2: string;
  ap_fecha_inicio: Date | null;
  ap_fecha_fin: Date | null;
  ap_usid_inicio: string;
  ap_usid_fin: string;
  ap_activo: boolean;
  arbitro1: ArbitroJSON | null;
  arbitro2: ArbitroJSON | null;
  usuarioInicio: UsuarioJSON | null;
  usuarioFin: UsuarioJSON | null;
}

export class ArbitroPareja {
  protected constructor(
    private id: string,
    private arbid1: string,
    private arbid2: string,
    private fechaInicio: Date,
    private fechaFin: Date | null,
    private usidInicio: string,
    private usidFin: string,
    private activo: boolean,
    private arbitro1: Arbitro | null,
    private arbitro2: Arbitro | null,
    private usuarioInicio: Usuario | null,
    private usuarioFin: Usuario | null
  ) {}

  static createFrom(
    id: string,
    arbid1: string,
    arbid2: string,
    fechaInicio: Date,
    fechaFin: Date | null,
    usidInicio: string,
    usidFin: string,
    activo: boolean,
    arbitro1: Arbitro | null,
    arbitro2: Arbitro | null,
    usuarioInicio: Usuario | null,
    usuarioFin: Usuario | null
  ) {
    return new this(
      id,
      arbid1,
      arbid2,
      fechaInicio,
      fechaFin,
      usidInicio,
      usidFin,
      activo,
      arbitro1,
      arbitro2,
      usuarioInicio,
      usuarioFin
    );
  }

  isIdentifiedBy(anId: string): boolean {
    return this.id === anId;
  }

  isIdentifiedAs(aEntity: ArbitroPareja) {
    if (this.id) {
      return aEntity.isIdentifiedBy(this.id);
    } else {
      return false;
    }
  }

  static fromJSON(entity: ArbitroParejaJSON) {
    return ArbitroPareja.createFrom(
      entity.ap_id,
      entity.ap_arbid_1,
      entity.ap_arbid_2,
      entity.ap_fecha_inicio ? new Date(entity.ap_fecha_inicio) : new Date(),
      entity.ap_fecha_fin ? new Date(entity.ap_fecha_fin) : null,
      entity.ap_usid_inicio,
      entity.ap_usid_fin,
      entity.ap_activo,
      entity.arbitro1 ? Arbitro.fromJSON(entity.arbitro1) : null,
      entity.arbitro2 ? Arbitro.fromJSON(entity.arbitro2) : null,
      entity.usuarioInicio ? Usuario.fromJSON(entity.usuarioInicio) : null,
      entity.usuarioFin ? Usuario.fromJSON(entity.usuarioFin) : null
    );
  }

  toJSON(): ArbitroParejaJSON {
    return {
      ap_id: this.getId(),
      ap_arbid_1: this.getArbid1(),
      ap_arbid_2: this.getArbid2(),
      ap_fecha_inicio: this.getFechaInicio(),
      ap_fecha_fin: this.getFechaFin(),
      ap_usid_inicio: this.getUsidInicio(),
      ap_usid_fin: this.getUsidFin(),
      ap_activo: this.getActivo(),
      arbitro1: this.getArbitro1() ? this.getArbitro1()!.toJSON() : null,
      arbitro2: this.getArbitro2() ? this.getArbitro2()!.toJSON() : null,
      usuarioInicio: this.getUsuarioInicio() ? this.getUsuarioInicio()!.toJSON() : null,
      usuarioFin: this.getUsuarioFin() ? this.getUsuarioFin()!.toJSON() : null,
    };
  }

  getId(): string {
    return this.id;
  }

  getArbid1(): string {
    return this.arbid1;
  }

  getArbid2(): string {
    return this.arbid2;
  }

  getFechaInicio(): Date {
    return this.fechaInicio;
  }

  getFechaFin() {
    return this.fechaFin;
  }

  getUsidInicio(): string {
    return this.usidInicio;
  }

  getUsidFin(): string {
    return this.usidFin;
  }

  getActivo(): boolean {
    return this.activo;
  }

  getArbitro1(): Arbitro | null {
    return this.arbitro1;
  }
  getArbitro2(): Arbitro | null {
    return this.arbitro2;
  }
  getUsuarioInicio(): Usuario | null {
    return this.usuarioInicio;
  }
  getUsuarioFin(): Usuario | null {
    return this.usuarioFin;
  }
}
